import { useState } from 'react';
import { Pencil, Trash2, Plus, ChevronLeft, Check } from 'lucide-react';
import { DEFAULT_MAX_TOKENS } from '../../../lib/presets.js';

/* ---------- 预设列表 ---------- */
export function PresetsList({
  presets,
  activeId,
  onActivate,
  onEdit,
  onDelete,
  onNew,
  onClose,
}) {
  return (
    <>
      <label className="ch-settings-label">
        全部预设 · <span className="ch-en">all presets</span>
      </label>

      {presets.length === 0 && (
        <div className="cc-empty">还没有预设 · 新建第一个</div>
      )}

      <div className="cc-list">
        {presets.map((p) => (
          <div
            key={p.id}
            className={'cc-card' + (p.id === activeId ? ' on' : '')}
          >
            <button
              className="cc-card-main"
              onClick={() => onActivate(p.id)}
              title={p.id === activeId ? '当前已激活' : '点击激活'}
            >
              <span className="cc-preset-icon" aria-hidden="true">⋆</span>
              <div className="cc-card-meta">
                <div className="cc-card-name">
                  {p.name}
                  {p.id === activeId && (
                    <span className="cc-card-on-tag">✦ 当前</span>
                  )}
                </div>
                <div className="cc-card-bio">
                  t={p.temperature.toFixed(2)} · max={p.max_tokens}
                  {p.system_addition?.trim()
                    ? ' · ' + p.system_addition.trim().slice(0, 30) +
                      (p.system_addition.trim().length > 30 ? '…' : '')
                    : ''}
                </div>
              </div>
            </button>
            <div className="cc-card-tools">
              <button
                className="cc-icon-btn"
                onClick={() => onEdit(p.id)}
                title="编辑"
                aria-label="编辑"
              >
                <Pencil size={13} strokeWidth={1.6} />
              </button>
              <button
                className="cc-icon-btn cc-icon-danger"
                onClick={() => onDelete(p.id)}
                title="删除"
                aria-label="删除"
              >
                <Trash2 size={13} strokeWidth={1.6} />
              </button>
            </div>
          </div>
        ))}
      </div>

      <button className="cc-add" onClick={onNew}>
        <Plus size={14} strokeWidth={1.8} /> 新建预设
      </button>

      <div className="ch-settings-actions">
        <button className="ch-tool-btn on" onClick={onClose}>
          完 成
        </button>
      </div>
    </>
  );
}

/* ---------- 预设编辑器 ---------- */
export function PresetEditor({ initial, onBack, onSave }) {
  const [draft, setDraft] = useState(initial);

  function patch(p) {
    setDraft((d) => ({ ...d, ...p }));
  }

  return (
    <>
      <div className="cc-editor-top">
        <button className="cc-back" onClick={onBack}>
          <ChevronLeft size={14} strokeWidth={1.6} /> 返回
        </button>
        <span className="cc-editor-title">编辑预设</span>
      </div>

      <label className="ch-settings-label cc-row-label">
        名 字 · <span className="ch-en">name</span>
      </label>
      <input
        className="ch-settings-input ch-settings-input-sm"
        value={draft.name}
        onChange={(e) => patch({ name: e.target.value })}
        placeholder="比如：细腻叙事"
      />

      <label className="ch-settings-label cc-row-label">
        风格 / 规则 · <span className="ch-en">system addition</span>
      </label>
      <textarea
        className="ch-settings-input"
        value={draft.system_addition}
        onChange={(e) => patch({ system_addition: e.target.value })}
        rows={6}
        placeholder={'比如：\n回答尽量带细腻的画面感和环境描写。\n用第二人称视角。\n避免列表式回答。'}
      />

      <label className="ch-settings-label cc-row-label">
        温 度 · <span className="ch-en">temperature</span>
        <span className="cc-slider-value">{draft.temperature.toFixed(2)}</span>
      </label>
      <div className="cc-slider-wrap">
        <input
          type="range"
          min="0"
          max="1"
          step="0.05"
          value={draft.temperature}
          onChange={(e) => patch({ temperature: parseFloat(e.target.value) })}
          className="cc-slider"
        />
        <div className="cc-slider-hint">
          <span>稳 · 精准</span>
          <span>野 · 跳脱</span>
        </div>
      </div>

      <label className="ch-settings-label cc-row-label">
        最大长度 · <span className="ch-en">max tokens</span>
      </label>
      <input
        type="number"
        className="ch-settings-input ch-settings-input-sm"
        value={draft.max_tokens}
        onChange={(e) =>
          patch({ max_tokens: Math.max(1, parseInt(e.target.value || '0', 10) || 0) })
        }
        min="1"
        max="32000"
        step="256"
        placeholder={String(DEFAULT_MAX_TOKENS)}
      />

      <div className="ch-settings-actions">
        <button className="ch-tool-btn" onClick={onBack}>
          取 消
        </button>
        <button className="ch-tool-btn on" onClick={() => onSave(draft)}>
          <Check size={13} strokeWidth={1.8} /> 保 存
        </button>
      </div>
    </>
  );
}

